var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-file-btn upload-btn",on:{"click":_vm.toUploadFile}},[_vm._t("default",[_c('button',{staticClass:"upload-file-default upload-default",attrs:{"type":"button","name":"upload-file-btn"}},[_vm._v("选择文件")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ade044e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadFile.vue
// module id = 96
// module chunks = 0